import { css } from '@emotion/css';

import { Colors } from '../../styles/constants';

export const dividerClassName = css({
  background: Colors.LightGray,
  height: 1,
  width: '100%',
});
